/*
Theme Name: Menlo Coaching
Theme URI: http://www.menlocoaching.com
*/

import '../../style.scss';
import '../../style-editor.scss';
import '../../scss/home.scss';
import '../../scss/early-birds.scss';
import '../../scss/interview-prep.scss';
import '../../scss/gmat-table.scss';
import '../../scss/mba-admissions-guide.scss';
import '../../scss/page-with-sidebar.scss';

import { initStickyNavbar } from './stickyNavbar';
import { loadWistiaVideo } from './loadWistiaVideo';
import { editWistiaJsonLd } from './editWistiaJsonLd';
import { openPaperform } from './openPaperform';
import { initNavMenu } from './navMenu';
import { initDesktopNavMenu } from './desktopNavMenu';
import { initMenloHubLayout } from './components/menloHubLayout';
import { initSidebarNavigation } from './sidebarNavigation';
import { initGmatTable } from './gmatTable';
import { initMcToc } from './mcToc';
import { initApplicantsFilters } from './applicantsFilters';

import jQuery from 'jquery';
import reframe from 'reframe.js';
import { initIdlePopup } from './idlePopup';
import { initExitIntent } from './exitIntent';
import { initLazyLoading } from './lazyLoading';
import { initVideoTracking } from './videoTracking';
import { SortableTable } from './components/sortableTable';
import { initFontFace } from './fontFaces';
import { insertPaperformPopup } from './insertPaperformPopup';

// Prevent Paperfrom from loading PayPal scripts
declare global {
  interface Window {
    paypal: unknown;
  }
}
window.paypal = 'DISABLED';

window.paperformDefaults = window.paperformDefaults || {};
window.loadWistiaVideo = loadWistiaVideo;
window.openPaperform = openPaperform;
window.initSidebarNavigation = initSidebarNavigation;
window.insertPaperformPopup = insertPaperformPopup;

jQuery(function () {
  initStickyNavbar();
  initDesktopNavMenu();
  initNavMenu();
  initGmatTable();
  initLazyLoading();
  initVideoTracking();
  initMcToc();
  initSidebarNavigation();
  if (window.options && window.options.idlePopup) {
    initIdlePopup(window.options.idlePopup);
  }
  initExitIntent();
  initApplicantsFilters();

  reframe('iframe[src^="https://fast.wistia.net"]');
  reframe('iframe[src^="https://www.youtube.com/embed/videoseries"]');
});

document
  .querySelectorAll<HTMLElement>('.is-sortable table')
  .forEach(el => new SortableTable(el));

initMenloHubLayout();
initFontFace();
editWistiaJsonLd();
